(() => {
  const DEBOUNCE_MS = 180;

  function setup(form) {
    const input = form.querySelector('input[type="search"][name="q"]');
    const dropdown = form.querySelector('[data-title-suggest-dropdown]');
    const results = form.querySelector('[data-title-suggest-results]');

    if (!input || !dropdown || !results) return;

    // 予測変換中（IME）に無駄打ちしない
    let composing = false;

    // ブラウザ履歴候補を抑止（ブラウザによって完全に消せない場合あり）
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('autocorrect', 'off');
    input.setAttribute('autocapitalize', 'off');
    input.setAttribute('spellcheck', 'false');

    let timer = null;
    let controller = null;

    const close = () => {
      dropdown.hidden = true;
      results.innerHTML = '';
    };

    const open = () => {
      dropdown.hidden = false;
    };

    const fetchSuggest = async () => {
      const q = input.value.trim();
      if (!q) {
        close();
        return;
      }

      if (controller) controller.abort();
      controller = new AbortController();

      const url = new URL('/search', window.location.origin);
      url.searchParams.set('view', 'title-suggest');
      url.searchParams.set('type', 'product');
      url.searchParams.set('options[prefix]', 'last');
      url.searchParams.set('q', q);

      try {
        const res = await fetch(url.toString(), {
          signal: controller.signal,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });

        if (!res.ok) {
          close();
          return;
        }

        const html = (await res.text()).trim();
        if (!html) {
          close();
          return;
        }

        results.innerHTML = html;
        open();
      } catch (e) {
        if (e.name === 'AbortError') return;
        close();
      }
    };

    const schedule = () => {
      clearTimeout(timer);
      timer = setTimeout(fetchSuggest, DEBOUNCE_MS);
    };

    input.addEventListener('compositionstart', () => { composing = true; });
    input.addEventListener('compositionend', () => { composing = false; schedule(); });

    input.addEventListener('input', () => {
      if (composing) return;
      schedule();
    });

    input.addEventListener('focus', () => {
      if (results.innerHTML.trim()) open();
    });

    input.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        close();
        input.blur();
      }
    });

    document.addEventListener('click', (e) => {
      if (!form.contains(e.target)) close();
    });

    form.addEventListener('submit', () => close());
  }

  document.addEventListener('DOMContentLoaded', () => {
    // ★ヘッダーのこのフォームだけ対象
    document.querySelectorAll('form.salowin-search-form').forEach(setup);
  });
})();
